import * as R from "ramda";
import { firebaseNormalizer } from "./global";
import { selectCurrentUser } from "./auth";
import { selectGroupByKey } from "./groups";

export const selectGroupActivities = (
  state,
  groupKey,
  tipoActividad,
  nivel
) => {
  const { respuestas, preguntas } = state.firebase;

  const realPreguntas = preguntas;
  const realRespuestas = respuestas;

  const respuestasFilter = R.whereEq({ groupKey, nivel, tipoActividad });
  const preguntasFilter = R.whereEq({ tipoActividad, nivel });

  const filteredRespuestas = R.filter(respuestasFilter, realRespuestas.byId);
  const filteredPreguntas = R.filter(preguntasFilter, realPreguntas.byId);

  return {
    preguntas: filteredPreguntas,
    respuestas: filteredRespuestas
  };
};

export const selectUserActivities = (state, submitUserId, nivel) => {
  const respuestas = firebaseNormalizer(state, "respuestas").filter(x => {
    if (x.submitUserId === submitUserId) {
      return true;
    }
    return false;
  });

  const preguntas = firebaseNormalizer(state, "preguntas").filter(x => {
    if (x.nivel === nivel) {
      return true;
    }
    return false;
  });

  return {
    respuestas,
    preguntas
  };
};

export const selectActivitiesByCurrentUser = state => {
  const { respuestas } = state.firebase;
  const currentUser = respuestas && selectCurrentUser(state);
  const resp = firebaseNormalizer(state, "respuestas");
  const filtered = resp.filter(x => {
    if (x.submitUserId === currentUser.uid) {
      return x;
    }
    return false;
  });
  return filtered;
};

export const selectActivitiesByGroupId = (state, groupKey) => {
  const respuestas = firebaseNormalizer(state, "respuestas");
  const group = selectGroupByKey(groupKey);

  const filteredGroups = respuestas.filter(
    respuesta => respuesta.groupKey === groupKey
  );

  return filteredGroups;
};

export const selectAllRespuestas = state => {
  return firebaseNormalizer(state, "respuestas");
};

export const selectAllPreguntas = state => {
  const allPreguntas = firebaseNormalizer(state, "preguntas");
  const filterEmpty = allPreguntas.filter(
    preguntas => preguntas.tipoActividad !== "empty"
  );
  return filterEmpty;
};

export const selectHighestPregunta = state => {
  const currentUser = selectCurrentUser(state);
  const preloadState = selectAllPreguntas(state);
  const preguntasNivel = preloadState.filter(
    pr => pr.nivel === currentUser.nivel
  );
  const etapa =
    preguntasNivel &&
    preguntasNivel.reduce(
      (max, shot) =>
        max &&
        max.tipoActividad !== "empty" &&
        max.numeroActividad > shot.numeroActividad
          ? max
          : shot,
      null
    );

  return etapa;
};
